<style>
</style>
<template>
  <div class="msgRecord-box">
    <p class="title">短信管理&nbsp;&nbsp;<strong>[ 短信订单 ]</strong>
    </p>
    <div class="container backfff">
      <div class="mb20 order-search-wrap">
        <span>订单号：</span>
        <el-input v-model.trim="orderNo" @keyup.enter.native="getMsgOrder()" style="width:200px;" prefix-icon="el-icon-search" placeholder="输入订单号" clearable></el-input>
        <span>模板名称：</span>
        <el-input v-model.trim="mouldName" @keyup.enter.native="getMsgOrder()" style="width:200px;" prefix-icon="el-icon-search" placeholder="输入模板名称" clearable></el-input>
        <span>处理状态：</span>
        <el-select v-model="status" @change="getMsgOrder()">
          <el-option label="全部" :value="-1"></el-option>
          <el-option label="禁止" :value="0"></el-option>
          <el-option label="待处理" :value="1"></el-option>
          <el-option label="已处理" :value="2"></el-option>
        </el-select>
        <el-button type="primary" class="ml20" @click="getMsgOrder()" >查询</el-button>
      </div>
      <div class="table-wrapper">
        <el-table :data="mdgRecordData" border highlight-current-row show-summary v-loading = "loading" ref="table" :max-height="tableHeight">
          <!-- <el-table-column label="用户ID"  prop="userId"></el-table-column> -->
          <el-table-column label="订单号" prop="orderNo"  width="200px"></el-table-column>
          <el-table-column label="门店名称" prop="shopName" width="200px"></el-table-column>
          <el-table-column label="模板名称" prop="mouldName" ></el-table-column>
          <el-table-column label="发送人数" prop="sendCount" ></el-table-column>

          <el-table-column label="发送成功数" prop="sendSuccNum" style="color: green" >
            <template slot-scope="scope">
              <span style="color: #67c23a">{{scope.row.sendSuccNum}}</span>
            </template>
          </el-table-column>
          <el-table-column label="发送失败数" prop="sendFailNum" style="color: red">
            <template slot-scope="scope">
              <span style="color: red">{{scope.row.sendFailNum}}</span>
            </template>
          </el-table-column>
          <el-table-column label="计费数" prop="billingNumber" >
            <template slot-scope="scope">
              <span style="color: blue">{{scope.row.billingNumber}}</span>
            </template>
          </el-table-column>
          <el-table-column label="实际计费数" prop="realBillingNum">
            <template slot-scope="scope">
              <span style="color: orange">{{scope.row.realBillingNum}}</span>
            </template>
          </el-table-column>
          <el-table-column label="失败计费数" prop="realBillingNum">
            <template slot-scope="scope">
              <span style="color: red">{{scope.row.billingNumber-scope.row.realBillingNum}}</span>
            </template>
          </el-table-column>
          <el-table-column label="处理状态" width="100">
            <template slot-scope="scope">
              <span style="color: red" v-if="scope.row.status == 0">禁止<i class="el-icon-error"></i></span>
              <span style="color: orange" v-else-if="scope.row.status == 1">待处理<i class="el-icon-warning"></i></span>
              <span style="color: #67c23a"  v-else>已处理<i class="el-icon-success"></i></span>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" prop="createTime"  width="200"></el-table-column>
          <el-table-column label="操作" fixed="right" width="90">
            <template slot-scope="scope">
              <span class="text-blue pointer" @click="ordersDetail(scope.row)">详情</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="txt-r mtop20">
        <el-pagination
          @size-change="sizeChange"
          @current-change="currentChange"
          :current-page="pageNum"
          :page-sizes="[ 20, 50, 100]"
          :page-size=pageSize
          layout="total, sizes, prev, pager, next, jumper"
          :total=total>
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import api from '../../server/api.js'
export default {
  name: "msgRecord",
  data(){
    return{
      tableHeight: 100,
      loading:false,
      orderNo : "",
      reqNo : -1,
      status:-1,
      mouldName:"",
      pageSize: 20,//当前显示条数
      pageNum: 1,//当前页数
      total: 0,//总数
      mdgRecordData: [],
    };
  },
  created(){
    this.getMsgOrder()
  },
  methods: {
    ordersDetail(row,index){//删除签名
      this.$router.push({name:'msgRecord',params: {orderNo:row.orderNo}})
    },
    getMsgOrder(){//获取列表
      let data = {
        "start": this.pageNum,
        "length": this.pageSize,
        "status": this.status == -1 ? null : this.status,
        // "startTime":
        // "endTime":
        // "userName":
        "orderNo": this.orderNo,
        "mouldName": this.mouldName
      }
      this.loading = true;
      api.getSmsOrderList({data:data}).then(res => {
        this.tableHeight =
          window.innerHeight - this.$refs.table.$el.offsetTop - 110;
        this.loading = false;
        if(res.status == 'success'){
          this.mdgRecordData = res.data.resultList;
          this.total = res.data.count;
        }
      })
    },
    sizeChange(v){//切换显示条数
      this.pageSize = v;
      this.getMsgOrder();
    },
    currentChange(v){//切换页数
      this.pageNum = v;
      this.getMsgOrder();
    },
  },
  components: {
    
  }
}
</script> 
  




// WEBPACK FOOTER //
// src/view/autograph/msgOrder.vue